import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-payments-new-gateway-dashboard',
  templateUrl: './payments-new-gateway-dashboard.component.html',
  styleUrls: ['./payments-new-gateway-dashboard.component.scss']
})
export class PaymentsNewGatewayDashboardComponent implements OnInit {

  providers;
  types;
  getGatewaysTypesSubscription: Subscription;
  getGatewaysProvidersSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private paymentsService: PaymentsService) { }

  ngOnInit() {
    this.getGatewayTypes();
    this.getGatewayProviders();
    this.setBreadcrumb();
  }

  private getGatewayTypes() {
    this.getGatewaysTypesSubscription = this.paymentsService.getTypes().pipe(
      tap(o => this.types = o)
    ).subscribe();
  }

  private getGatewayProviders() {
    this.getGatewaysProvidersSubscription = this.paymentsService.getProviders().pipe(
      tap(o => this.providers = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cash-register', 'gateways-page.gateways', '/payments/gateways', [new BRoute('gateways-page.payments', '/payments'), new BRoute('gateways-page.gateways', '/payments/gateways'), new BRoute('gateways-page.new gateway')]));
  }
}
